import { Link } from "react-router-dom";

export function NomMark({ className = "h-8 w-8" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} role="img" aria-label="Nom Apps logo" data-testid="nom-apps-logo-mark">
      <rect x="6" y="8" width="52" height="48" rx="24" fill="#FFAA99" />
      <rect x="16" y="23" width="8" height="11" rx="4" fill="#2B2D42" />
      <rect x="40" y="23" width="8" height="11" rx="4" fill="#2B2D42" />
      <rect x="18.5" y="25" width="2.5" height="2.5" rx="1.25" fill="#FFFFFF" />
      <rect x="42.5" y="25" width="2.5" height="2.5" rx="1.25" fill="#FFFFFF" />
      <rect x="10" y="36" width="8" height="4.5" rx="2.25" fill="#FF7369" opacity="0.75" />
      <rect x="46" y="36" width="8" height="4.5" rx="2.25" fill="#FF7369" opacity="0.75" />
      <path d="M24 40 a8 6 0 0 0 16 0" fill="none" stroke="#2B2D42" strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  );
}

export default function Logo({ dark = false }) {
  return (
    <Link to="/" className="flex items-center gap-2.5 group" data-testid="logo-home-link" aria-label="Nom Apps LLC home">
      <NomMark className="h-8 w-8 transition-transform duration-300 group-hover:-rotate-6" />
      <span className={`font-display text-xl font-semibold tracking-tight ${dark ? "text-white" : "text-nom-ink"}`}>
        Nom Apps
      </span>
    </Link>
  );
}
